import React from 'react';

export function Field({ label, value, onChange, placeholder, area, type = 'text' }) {
  return (
    <label className="field">
      <span className="field-label">{label}</span>
      {area ? (
        <textarea value={value ?? ''} onChange={onChange} placeholder={placeholder} rows={3} />
      ) : (
        <input type={type} value={value ?? ''} onChange={onChange} placeholder={placeholder} />
      )}
    </label>
  );
}

export function MapSelect({ label, value, onChange, headers, allowNone }) {
  return (
    <label className="field small">
      <span className="field-label">{label}</span>
      <select value={value} onChange={(e) => onChange(Number(e.target.value))}>
        {allowNone && <option value={-1}>—</option>}
        {headers.map((h, i) => <option key={i} value={i}>{h || `Colonne ${i + 1}`}</option>)}
      </select>
    </label>
  );
}
